import React from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars-2";
import errorImage from "../../../../assets/images/miscellaneous_package.png";
import { resolveFormIcon } from "../utils/formIcons";

export const ProductGrid = ({
	t,
	searchRef,
	searchQuery,
	onSearchChange,
	products,
	onProductClick,
}) => (
	<>
		<Form.Control
			ref={searchRef}
			type="text"
			className="mb-3 search-product sale-search"
			value={searchQuery}
			onChange={(event) => onSearchChange(event.target.value)}
			placeholder={t("Search product...")}
		/>
		<Card className="pos-body" style={{ flex: "1 1 auto", overflow: "hidden" }}>
			<Card.Body style={{ height: "100%", display: "flex", flexDirection: "column" }}>
				<Scrollbars
					autoHide
					style={{ height: "100%" }}
					universal
					renderTrackHorizontal={(props) => <div {...props} style={{ display: "none" }} />}
				>
					<Row className="g-3" style={{ margin: 0 }}>
						{products.map((product) => {
							const icon = resolveFormIcon(product);
							const isOutOfStock = product.totalRemainingMedicine === 0;
							return (
								<Col xs={6} md={4} key={product._id} className="mt-0">
									<Card className={`pos-item-grid-card ${isOutOfStock ? "disabled-card" : ""}`} onClick={() => {
										if (!isOutOfStock) onProductClick(product);
									}}
										style={{
											cursor: isOutOfStock ? "not-allowed" : "pointer",
											opacity: isOutOfStock ? 0.5 : 1,
										}}>
										<div className="relative">
											<div className="pos-box-img">
												<img
													src={icon}
													onError={(event) => {
														event.target.src = errorImage;
													}}
													alt={product.brandName}
												/>
											</div>
											<span className="box-qty">{product.totalRemainingMedicine}</span>
										</div>
										<Card.Body className="p-2">
											<small
												className="text-muted d-block text-truncate"
												style={{ maxWidth: "100%" }}
												title={product.isOTC ? product.productForm : product.saltName}
											>
												{product.isOTC ? product.productForm : product.saltName}
											</small>
											<Card.Title
												style={{ fontSize: "12.4px", maxWidth: "100%" }}
												className="d-block text-truncate"
												title={product.brandName}
											>
												{product.brandName}
											</Card.Title>
											{/* {isOutOfStock && (
												<div className="text-danger fw-bold small mt-1">{t("Out of Stock")}</div>
											)} */}
										</Card.Body>
									</Card>
								</Col>
							);
						})}
						{products.length === 0 && (
							<Col md={12}>
								<div className="text-muted">{t("No products found")}</div>
							</Col>
						)}
					</Row>
				</Scrollbars>
			</Card.Body>
		</Card>
	</>
);

export default ProductGrid;

